// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__pg6G9","pagination__control":"pagination_pagination__control__t2yXd"};